export function postBody(body: any) : RequestInit {
    return requestBody(body, "POST")
}

export function requestBody(body: any, method: string) : RequestInit {
    return {
        method: method,
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(body)
    }
}